export default "__VITE_ASSET__Bv96zsgm__"